export default function (nga, admin) {

    var activity = admin.getEntity('activities');
    activity.listView()
        .title('{{ "Activities" | translate }}')
        .fields([
            nga.field('name', 'text')
                .label('Name')
                .isDetailLink(true)
        ])
        .filters([
            nga.field('q', 'template')
                .label('')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
        ])
        .sortField('name')
        .sortDir('DESC')
        .actions(['create', 'filter'])
        .listActions([
            '<ma-filtered-list-button entity-name="exercises" filter="{ activity_id: entry.values.id }" size="xs"></ma-filtered-list-button>',
            '<ma-filtered-list-button entity-name="properties" filter="{ activity_id: entry.values.id }" size="xs"></ma-filtered-list-button>',
            'edit'
        ]);
    activity.creationView()
        .fields([
            nga.field('name')
                .validation({ required: true })
        ])
    activity.editionView()
        .title('{{ "EDIT" | translate }}')
        .fields(activity.creationView().fields())

    return activity;
}



// WEBPACK FOOTER //
// ./js/activities/config.js